import Vue from 'vue'
// import VueRichTextRenderer from '@marvr/storyblok-rich-text-vue-renderer'
import RichTextRenderer from '@marvinrudolph/vue-storyblok-rich-text-renderer'

Vue.use(RichTextRenderer)
